// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const borderRadius = 3;

export const departments = ["Obstetrics and Gynaecology"];
